import { PropsWithChildren } from 'react';

export const SectionTitle = ({ children }: PropsWithChildren) => {
    return <h1 className="text-lg font-semibold">{children}</h1>;
};

SectionTitle.displayName = 'SectionTitle';
